import { render, staticRenderFns } from "./Project1.vue?vue&type=template&id=6d6e7fe6&"
import script from "./Project1.vue?vue&type=script&lang=js&"
export * from "./Project1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports